import { createSelector } from "@reduxjs/toolkit";

import { IUserDrivingPermit } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { buildData, dataSelector } from "../helpers";

export const userDrivingPermitsSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userDrivingPermit) as IUserDrivingPermit[]
);

const dataUserDrivingPermitsSelector = createSelector(dataSelector, data => data.userDrivingPermit);

export const userDrivingPermitSelectorCreator = (id: string) =>
  createSelector(dataUserDrivingPermitsSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_DRIVING_PERMIT(id)];
    return item ? (buildSingleItem(item) as IUserDrivingPermit) : undefined;
  });
